import { render, staticRenderFns } from "./act-finish.vue?vue&type=template&id=2fa0adc2&scoped=true&"
import script from "./act-finish.vue?vue&type=script&lang=js&"
export * from "./act-finish.vue?vue&type=script&lang=js&"
import style0 from "./act-finish.vue?vue&type=style&index=0&id=2fa0adc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0adc2",
  null
  
)

export default component.exports